import { BlockConfigParams } from './btm-block';

export interface BtmPageShowInfo extends BtmExposeInfo {
  enter_time: number;
  launch_id: string;
  btm_page_params: Record<string, string>;
  btm_pre_unit_params?: Record<string, any> | null;
  unique_id: string;
}

export interface BtmExposeInfo {
  btm: string;
  btm_pre?: string | null;
  btm_ppre?: string | null;
  btm_show_id?: string;
  btm_pre_show_id?: string;
  btm_sdk_version?: string | null;
  current_url?: string;
  is_prod?: string;
}

export interface LinkEventParams {
  btm: string;
  btm_pre?: string | null;
  btm_ppre?: string | null;
  btm_show_id: number;
  unitParams?: Record<string, any> | null;
}

export interface TeaInitParams {
  tea?: any;
  teaVersion?: string;
  cdnReportName?: string;
}

export interface UrlQueryParams {
  btm_ppre: string;
  btm_pre: string;
  btm_show_id?: string;
  btm_pre_unit_params?: string;
}

/**
 *  系统级别 初始化 曝光埋点 在业务Tea.init之后调用
 *  btmAId: BTM系统平台ID，即A位
 *  unique_id: 业务系统用户唯一ID
 *  teaInitParams: tea上报的实例或者cdnReportName以及tea的版本
 *  autoTrack: 是否自动监听路由变更
 *  spaConfig: spa页面 路由和b点位的映射
 *  enableHeatmap: 是否启用热力图
 *  isMPA: 是否是多页应用
 */
export interface BtmInitParams {
  /** BTM系统平台ID，即A位 */
  btmAId: string;
  /** 业务系统用户唯一ID */
  uniqueId: string;
  /** Tea 初始化参数 */
  teaInitParams?: TeaInitParams;
  /** 单元应用下路由与B位的映射配置 */
  spaConfig?: Record<string, string>;
  /** 单元应用下页面正则与B位的映射配置 */
  pagePattern?: Record<string, string>;
  /** 接入系统是否是 MPA */
  isMPA?: boolean;
  /** 应用名称，请求tcc页面规则的 */
  appName?: string;
  /** 区块曝光配置  */
  blockConfig?: BlockConfigParams;
  /** 上报方法 */
  customReport?: (event: string, params: Record<string, any>) => void;
  /** 上报回调函数 */
  reportCallback?: () => void;
  /** 是否需要上报这个页面 */
  isNeedReportPage?: () => boolean;
  /** 是否展示log，方便调试 */
  devLog?: boolean;
  /** 业务请求机制，key 为 btm 点位，value 为对应的 url */
  bizUrlMap?: Record<string, string[]>;
  /** 国家，默认值为 sg，可选 'gb' | 'id' | 'my' | 'ph' | 'sa' | 'sg' | 'th' | 'us' | 'vn' */
  region?: IRegion;
}

export type IRegion = 'gb' | 'id' | 'my' | 'ph' | 'sa' | 'sg' | 'th' | 'us' | 'vn';

export interface TeaParams {
  eventName: string;
  eventParams: Record<string, any>;
}
export interface BusinessReportParams {
  teaParams: TeaParams;
  target: HTMLElement | null;
}

export interface IActionRecord {
  action_btm: string;
  ts: number;

  /**
   * 仅对合法的 index d 点位生效，格式为：
   * d0123_i${index}
   * d0123_i${index}_i${index}
   * d0123_i${index}_i${index}_i${index}
   * */
  primary_index?: string;
  secondary_index?: string;
  third_index?: string;
}

export interface IManualOpts {
  type: 'click' | 'expose' | 'pageShow' | 'disappear';
  target?: HTMLElement | null;
  btm?: string;
  params?: Record<string, unknown>;
  btmBId?: string;
  duration?: number;
  ts?: number;
  useBeacon?: boolean;
}

// 标准事件类型
export enum BTMEventType {
  PageShow = 'btm_page_show', // B 页面曝光事件
  ModuleShow = 'btm_block_expose', // C 模块曝光事件
  ModuleDisappear = 'btm_block_disappear', // C 模块曝光结束事件
  Click = 'btm_block_click', // D 点位点击事件

  /** 业务请求相关 */
  BizStart = 'biz_start', // 业务请求开始
  BizFail = 'biz_fail', // 业务请求失败
  BizSucceed = 'biz_succeed' // 业务接口请求失败
}

export interface RemoteConfig {
  urlRegexConfKeys?: Array<MapItem>;
  bizUrlConfig?: Record<string, string[]>;
  pageConfig?: {
    disablePageShow?: string[];
    enableFullTracking?: string[];
    positions?: {
      btmCode: string;
      selectors: string[];
    }[];
  };
  moduleConfig?: {
    disableModuleExpose?: string[];
    enableModuleDuration?: string[];
  };
  locationConfig?: {
    disableBlockClick?: string[];
  };
  copywritingConfig?: {
    enableCopyWriting?: boolean;
    sampleRatio?: number;
    starlingSampleRatio?: number;
  };
}

interface MapItem {
  btmFullCode: string;
  urlRegex: Array<string>;
  pagePath: Array<string>;
}

export interface EventMap {
  init: (btmInfo: BtmPageShowInfo) => void;
  config: (btmInfo?: RemoteConfig) => void;
  logSent: (data: { action_btm: string; ts: number }) => void;
  // Add more events as needed
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6IiIsIm5hbWVzIjpbXSwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXX0=